import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-product-video-tab',
    templateUrl: './uig-product-video-tab.component.html',
    styleUrls: ['./uig-product-video-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigProductVideoTabComponent implements OnInit {

  product$: Observable<Product>;

  constructor(protected currentProductService: CurrentProductService) { }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

}
